import { format as formatFns } from 'date-fns';
import { ElementType, memo } from 'react';

type FormatOptions = Parameters<typeof formatFns>[2];

type DateTimeProps<T extends React.ElementType> = React.ComponentPropsWithoutRef<T> & {
  as?: T;
  value: string | number | Date | null | undefined;
  format?: string;
  options?: FormatOptions;
  componentTag?: ElementType;
};

function formatDateTime(
  date: string | number | Date | null | undefined,
  formatString: string,
  options = {},
) {
  let _date = date;

  if (!_date) {
    return '';
  }

  if (typeof _date === 'string' || typeof _date === 'number') {
    try {
      _date = new Date(_date);
    } catch (err) {
      console.error(err);

      return '';
    }
  }

  return formatFns(_date, formatString, {
    weekStartsOn: 1,
    ...options,
  });
}

function DateTime<T extends React.ElementType = 'p'>({
  as,
  value,
  format = 'PPpp',
  options,
  ...rest
}: DateTimeProps<T>) {
  const Component = as || 'p';

  return <Component {...rest}>{formatDateTime(value, format, options)}</Component>;
}
export default memo(DateTime);
